import userManagement from "@/components/userManagement/index.vue";
import allUser from "@/components/userManagement/userManagement.vue"
import blacklistManage from '@/components/userManagement/blacklistManage.vue'

export default {
    router: {
        path: "/userManagement",
        name: "userManagement",
        component: userManagement,
        props: true,
        children: [
            {
                path: "allUser",
                name: "allUser",
                component: allUser,
                props: true
            }, {
                path: 'blacklistManage',
                name: 'blacklistManage',
                component: blacklistManage,
                props: true
            }
        ]
    }
}